<template>
    <!-- Кнопка "Скачування документу" -->
    <div>
        <button
            class="btn btn-info"
            v-if="this.perms[2000] === true || this.user.userid === 111"
            @click="this.showDatePicker = true"
            style="margin-bottom: 20px;"
        >
            <i class='bx bx-download'></i>
            {{ $t("Download") + " " + $t("statReport") }}
        </button>
    </div>

    <tablecustom
        :rows="this.rows"
        :columns="this.columns"
        :objParams="this.objParams"
        :objPages="this.objPages"
        :dataParams="this.dataParams"
        @getdata="getdata()"
    />

    <!-- Модалка дат -->
    <dialogModal v-if="showDatePicker" @close="this.showDatePicker = false">
        <template v-slot:title>{{ $t('Download') }}</template>
        <template v-slot:body>
            <div class="mt-4 text-center row">
                <div class="col-md-6">
                    <!-- Інпути для дат -->
                    <input
                        v-model="this.excelForm.pr1"
                        type="date"
                        class="form-control col-md-6"
                        min="2024-01-01"
                    >
                </div>
                <div class="col-md-6">
                    <input
                        v-model="this.excelForm.pr2"
                        type="date"
                        class="form-control col-md-6"
                        min="2024-01-01"
                    >
                </div>
            </div>
        </template>
        <template v-slot:footer-bottom>
            <div class="hstack gap-2 mt-3 justify-content-center remove">
                <!-- Кнопка скачування -->
                <button
                    class="btn btn-success"
                    @click="downloadExcel"
                >
                    {{ $t('Download') }}
                </button>
                <button
                    class="btn btn-danger"
                    @click="showDatePicker = false"
                >
                    {{ $t('close') }}
                </button>
            </div>
        </template>
    </dialogModal>
</template>

<script>
import tablecustom from "@/components/globaltable/index.vue"
import dialogModal from "@/components/modal/dialog.vue"
import { DataCalendar } from '../../../API'
import { storeS } from "@/store"
import axios from "axios"

let apiServe = new DataCalendar()

export default {
    data() {
        return {
            showDatePicker: false,
            excelForm: {
                pr1: '',
                pr2: '',
                companyId: '',
                token: '',
                type: 'clinic'
            },
            rows: [],
            columns: [
                {
                    name: 'id',
                    text: 'id',
                    status: true
                },
                {
                    name: this.$t('Point_name'),
                    text: 'name',
                    status: true
                },
                {
                    name: this.$t('Employee'),
                    text: 'createWorkerName',
                    status: true
                },
                {
                    name: this.$t('ofRemaining'),
                    text: 'date',
                    status: true
                },
                {
                    name: this.$t('to'),
                    text: 'toDate',
                    status: true
                }
            ],
            objParams: {
                types: JSON.stringify(["clinic"])
            },
        }
    },
    components: {
        tablecustom,
        dialogModal
    },
    created() {
        this.getdata();
        // Ініціалізація token та companyId
        [this.excelForm.token, this.excelForm.companyId] =
        [storeS.savedTokenAndCompany.split('&companyId=')[0],
        storeS.savedTokenAndCompany.split('&companyId=')[1]]
    },
    methods: {
        // Скачка файлу Excel
        downloadExcel() {
            // Сам запит для отримання Excel
            if(this.excelForm.pr1 != '' && this.excelForm.pr2 != '') {
                const fetchData = async () => {
                    try{
                        // Запит на апі, передача параметрів
                        const response = await axios.get("https://pdf-inside.mysky.team/excel.php", {
                            params: {
                                pr1: this.excelForm.pr1,
                                pr2: this.excelForm.pr2,
                                compId: this.excelForm.companyId,
                                token: this.excelForm.token,
                                type: this.excelForm.type
                            },
                            responseType: 'blob' // обробка файлу
                        });

                        // Створюємо URL для файлу
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'clinic.xlsx'); // Вказуємо ім'я файлу
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } catch (error) {
                        console.error("Помилка при завантаженні файлу:", error);
                    }
                };

                fetchData() // виклик функції
            }
        },
        getdata() {
            apiServe.getEvents(this.objParams).then(result => {
                console.log(result)
                if(result.status === 'done') {
                    this.rows = result.data.events
                }
            })
        }
    },
    computed: {
        perms() {
            /*
                Отримуємо дані прав доступу з глобального стору.
            */
            return storeS.perms
        },
        user() {
            /*
                Отримуємо дані користувача з глобального стору.
            */
            return storeS.userbase
        }
    }
}
</script>

<style lang="scss" scoped>

</style>